const autoprefixer = require("autoprefixer");

module.exports = {
  siteMetadata: {
    title: "Jakten på den oslipade diamanten"
  },
  plugins: [
    "gatsby-plugin-react-helmet",
    {
      resolve: "gatsby-plugin-postcss-sass",
      options: {
        postCssPlugins: [autoprefixer()],
        precision: 8
      }
    },
    {
      resolve: "gatsby-plugin-google-fonts",
      options: {
        fonts: ["open sans:300,400,400i,600,600i,700"]
      }
    },
    {
      resolve: "gatsby-plugin-google-analytics",
      options: {
        trackingId: "UA-121213967-1",
        head: true
      }
    },
    {
      resolve: "gatsby-plugin-mailchimp",
      options: {
        endpoint:
          "https://arbetsgivare.us18.list-manage.com/subscribe/post?u=98f4366fade0de46175002b12&amp;id=559a3b5cec"
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./gatsby-config.js